<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-tone`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zM6.11 26c.995 9 8.625 16 17.89 16s16.895-7 17.89-16H6.11zm0-4C7.104 13 14.735 6 24 6s16.896 7 17.89 16H6.11z"/></svg>
</template>
<script>

export default {
  name: 'IconTone',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
